import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {isMobile} from 'react-device-detect';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import ContactUsAction from 'app/Components/Shared/ContactUs/ContactUsAction';
import {contactUsBankNotInList, stepEnum} from '../../Constants/debtPaymentEnum';
import {setSelectedUpdatePaymentType, selectSelectedBanData, selectServerData, selectEpiData} from '../../DebtAndUpdatePaymentBlockSlice';
import {useDebtPaymentPopupData} from '../../hooks/useDebtPaymentPopupData';
import {dwhUpdatePaymentMethodReport, DwhActionType, DWHMessageText, DWHStatus} from '../../reports/dwhReports';
import Image from 'app/Components/Shared/Image/image';

const BankNotInListPopup = () => {
  const dispatch = useDispatch();
  const {actions} = useDebtPaymentPopupData();
  const selectedBanData = useSelector(selectSelectedBanData);
  const allBans = useSelector(selectServerData);
  const epiData = useSelector(selectEpiData);
  const loginData = useSelector((state) => state.authentication.loginData);
  const selectedBansForPaymentUpdate = useSelector((state) => state.debtAndUpdatePayment.selectedBansForPaymentUpdate);

  useEffect(() => {
    dwhUpdatePaymentMethodReport({
      banData: selectedBanData,
      loginData,
      allBans,
      selectedBanNumbers: selectedBansForPaymentUpdate,
      actionType: DwhActionType.StandingOrderAccountPage,
      messageText: DWHMessageText.NonDigitalBankPopupDisplayed,
      status: DWHStatus.Ongoing,
      lastPaymentTypeValidation: epiData?.lastPaymentTypeValidation,
    });
  }, []);

  const handleGoToCreditCard = () => {
    dispatch(setSelectedUpdatePaymentType('creditcard'));
    actions.setShowPopup({showPopUp: false});
    actions.goToStep(stepEnum.CREDITCARD);
  };

  return (
    <div className='bank-not-in-list-popup'>
      <div className='debt-payment-popup-image'>
        <Image src={require('../../images/error.svg')} alt='' />
      </div>
      <div className={`popup-title ${isMobile ? 'm-title' : 'l-title'}`}>אם הבנק שלך לא מופיע ברשימה</div>
      <div className='bank-not-in-list-popup__text'>
        ניתן להשלים את התהליך בקלות מול נציג של {window.Config.brand_Name_HE},
        <br />
        או לעבור לעדכון דרך כרטיס אשראי
      </div>
      <div className='bank-not-in-list-popup__contact'>
        <ContactUsAction contentData={contactUsBankNotInList} />
      </div>
      <div className='debt-payment-popup-actions'>
        <BtnSubmit onclick={handleGoToCreditCard} text='לתשלום קבוע דרך כרטיס אשראי' />
      </div>
    </div>
  );
};

export default BankNotInListPopup;
